<script setup>
import { useFianlyBranding } from './useFianlyBranding';
import defaultLogo from './assets/logo-fianly.png';
import brandMark from './assets/logo-fianly-small.png';

defineProps({ compact: { type: Boolean, default: false } });
const WORDMARK = { name: 'fianly', product: 'atiende' };
const { logo, logoDark, installationName } = useFianlyBranding();
</script>

<template>
  <div class="flex justify-center">
    <div
      v-if="logo === defaultLogo"
      class="flex items-center"
      :class="compact ? 'gap-2' : 'gap-4'"
      :aria-label="installationName"
    >
      <div
        class="relative overflow-hidden"
        :class="
          compact ? 'h-10 w-11' : 'h-[4.75rem] w-20 sm:h-[5.25rem] sm:w-24'
        "
        aria-hidden="true"
      >
        <img
          :src="brandMark"
          alt=""
          class="absolute max-w-none"
          :class="
            compact
              ? '-start-2 top-0 w-[3.75rem]'
              : '-start-4 top-0 w-28 sm:-start-5 sm:-top-0.5 sm:w-32'
          "
        />
      </div>
      <div
        class="border-s border-[var(--fianly-accent)] text-n-slate-12"
        :class="compact ? 'ps-2' : 'ps-4'"
      >
        <div
          class="font-medium leading-none tracking-tight"
          :class="compact ? 'text-2xl' : 'text-4xl sm:text-5xl'"
        >
          {{ WORDMARK.name }}
        </div>
        <div
          class="mt-1 leading-none tracking-wide"
          :class="compact ? 'text-sm' : 'text-xl sm:text-2xl'"
        >
          {{ WORDMARK.product }}
        </div>
      </div>
    </div>
    <template v-else>
      <img
        :src="logo"
        :alt="installationName"
        class="max-w-full object-contain dark:hidden"
        :class="compact ? 'h-10' : 'h-28'"
      />
      <img
        :src="logoDark"
        :alt="installationName"
        class="hidden max-w-full object-contain dark:block"
        :class="compact ? 'h-10' : 'h-28'"
      />
    </template>
  </div>
</template>
